import { photoSrc } from "@/components/RoomPhotosUploader";

export default function CoachAvatar({ coach, size = "w-14 h-14", textSize = "text-lg" }) {
  if (coach.photo_url)
    return <img src={photoSrc(coach.photo_url)} alt={coach.name} className={`${size} rounded-full object-cover border-2 border-orange-500/30`} data-testid={`coach-avatar-${coach.id}`} />;
  return (
    <div className={`${size} rounded-full bg-orange-500/10 text-orange-700 grid place-items-center font-bold ${textSize}`} data-testid={`coach-avatar-${coach.id}`}>
      {(coach.name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("")}
    </div>
  );
}
